import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NetworkConnectionService {

  constructor(private http: HttpClient) { }

  check(): Observable<boolean> {
    return this.checkPage('').pipe(
      map(res => res.status === 200),
      catchError(() => throwError(false)),
    );
  }

  /**
   * Sirve para checkear  la conexión a internet.
   * @param url ruta para testear la conexión.
   */
  checkPage(url: string) {
    return this.http.get(url, { observe: 'response', responseType: 'text' });
  }

}
